module.exports = __webpack_public_path__ + "img/H-B-3-load-standup-shadow.2c6af3a9.png";